import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import React, { useState, useEffect } from 'react';
import Capcalera from './Capcalera';
import Cos from './Cos';
import MediaDestacat from './MediaDestacat';
import PuntsClau from './PuntsClau';
import StickyHeader from './StickyHeader';
import TemesRelacionats from './TemesRelacionats';
import styles from './itemnoticia.module.scss';
import ModulMiradaGlobal from 'components/3catinfo/ModulMiradaGlobal';

const ItemNoticia = (props) => {
    const { cos, className, puntsClau, tags } = props;
    const [isPreview, setIsPreview] = useState(false);

    useEffect(() => {
        function getPreviewStatus() {
            if (typeof window === 'undefined') {
                return false;
            }
            const currentUrl = window.location.href;

            return currentUrl.includes('preview=true');
        }
        setIsPreview(getPreviewStatus());
    }, []);

    const stylesNoticia = clsx({
        [styles.itemnoticia]: true,
        [styles.preview]: isPreview,
        [styles[className]]: !__isEmpty(className)
    });

    return (
        <article className={stylesNoticia} data-testid='item-noticia'>
            <Capcalera {...props} />
            <StickyHeader {...props}>
                <MediaDestacat {...props} />
                <PuntsClau cos={puntsClau} />
                {/* <Resum id={id} /> */}
                <Cos cos={cos} />
                {Array.isArray(tags) && tags.some((tag) => tag.id === 'INTERNACIONA') && (
                    <div className={styles.miradaGlobal}>
                        <ModulMiradaGlobal
                            titol='Butlletí Mirada Global'
                            text='Les claus per entendre cap on va el món, de la mà dels nostres experts'
                            textBoto='Subscriu-t’hi'
                            linkBoto='/butlletins/3catinfo/50/'
                            estil='noticia'
                        />
                    </div>
                )}
                <TemesRelacionats data={tags} />
            </StickyHeader>
        </article>
    );
};

export default ItemNoticia;
